import script from "./SettingDashboardAlertPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingDashboardAlertPage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingDashboardAlertPage.vue?vue&type=style&index=0&id=48ed4d8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ed4d8c"]])

export default __exports__